import type { PayloadAction } from '@reduxjs/toolkit';
import type { IntegrationStep, PartnerIntegrationState } from 'src/types/partner-integration';

const reducers = {
  updateIntegrationStep: (
    state: PartnerIntegrationState,
    action: PayloadAction<IntegrationStep>,
  ) => ({
    ...state,
    step: action.payload,
  }),
};

export default reducers;
